import { v4 } from 'uuid';
import { TRACE_ID_NAME } from './constants';
import {
  AffordabilityFormDataType,
  AffordabilityRequest,
  AffordabilityResponse,
  MaritalStatusEnum,
  maritalStatuses,
} from './types';

const affordabilityMock: AffordabilityResponse = { loanAmount: 1_000_000, interestRate: 0.008 };

export async function fetchAffordability(
  data: AffordabilityFormDataType,
  mocked = process.env.NODE_ENV === 'development',
): Promise<AffordabilityResponse> {
  if (mocked) {
    return new Promise((resolve, _reject) => {
      setTimeout(() => {
        resolve(affordabilityMock);
        // _reject('Error')
      }, 1000); // Simulate network delay
    });
  }

  const coApplicant =
    data.secondaryApplicantExist === '1'
      ? { coapplicant: { netMonthlyIncome: parseInt(data.secondaryApplicantIncome) } }
      : undefined;

  const requestData: AffordabilityRequest = {
    applicant: {
      netMonthlyIncome: parseInt(data.primaryApplicantIncome),
    },
    ...coApplicant,
    maritalstatus:
      data.maritalStatus === maritalStatuses.married || data.maritalStatus === maritalStatuses.cohabitant
        ? MaritalStatusEnum.MARRIED
        : MaritalStatusEnum.SINGLE,
    numberOfChildren: data.children,
    numberOfCars: data.cars,
    properties: data.propertiesToSell
      ? [
          {
            type: 'APARTMENT',
            remainingDebt: parseInt(data.loansRemainingBalance),
            shareOfHousingLoan: parseInt(data.housingCompanyDebt),
          },
        ]
      : [],
    loans: data.otherLoans
      ? [
          {
            type: 'OTHER_LOAN',
            remainingDebt: parseInt(data.personalLoansBalance),
          },
        ]
      : [],
    creditCards: data.creditCards
      ? [
          {
            limit: parseInt(data.creditCardsLimit),
          },
        ]
      : [],
  };

  const init: RequestInit = {
    body: JSON.stringify(requestData),
    headers: { 'Content-Type': 'application/json', [TRACE_ID_NAME]: v4() },
    method: 'POST',
  };

  const url = `https://${window.location.host}/lainat/api/calculator/fi/calculate-limit`;

  return fetch(url, init).then((response) => {
    if (response.ok) {
      return response.json();
    }

    throw new Error('Request could not be completed due to error');
  });
}
